<template lang="pug">
  .select-vendors
    el-row
      el-col(:span="24")
        el-button(
          v-if="!isView"
          @click="dialogVisible = true"
          style="margin-bottom: 10px"
        ) {{ $t('添加供应商') }}
        VendorBriefTable(
          :data="deliverVendorList"
          @selectedChange="handleSelectionChange"
          @retry="fetchVendorList"
          @updateDeliverVendor="fetchDeliverVendorList"
        )
        el-button(
          :disabled="disableDeliverButton || selectedList.length === 0"
          v-if="!isView"
          @click="handleDeliver"
          style="margin-top: 10px"
        ) {{ $t('点击下发') }}

    el-dialog(
      :title="$t('添加供应商')"
      :visible.sync="dialogVisible"
      @open="clearSelectForm"
      :close-on-click-modal="false"
      center
    )
      select-vendors-container(
        :title="$t('选择供应商')"
        :selectedVendors="selectedVendors"
        @change="(val) => selectedVendors = val"
        :categorys="categorys"
        :disabledVendorList="deliverVendorList.concat(selectedVendors)"
      )
      div(style="text-align:center")
        footer-button(
          @confirm="confirm"
          @cancel="cancel"
        )
</template>

<script>
import VendorBriefTable from './VendorBriefTable'
import FooterButton from '@/components/FooterButton'
import SelectVendorsContainer from '@/components/SelectVendorsContainer'
import { format4backend } from '@/umcc/util'
import axios from 'axios'
import { pickBy } from 'lodash'

export default {
  components: {
    VendorBriefTable,
    FooterButton,
    SelectVendorsContainer
  },
  props: {
    categorys: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      dialogVisible: false,
      form: {
        vendors: []
      },
      deliverVendorList: [],
      selectedList: [],
      vendorList: [],
      fileName: null,
      selectedVendors: [{
        is_storage: 1,
        struct_group_name: '',
        struct_group_id: null
      }]
    }
  },
  computed: {
    campaignID () {
      return this.$store.state.campaign.id
    },
    disableDeliverButton () {
      return this.deliverVendorList.every(l => !l.can_deliver)
    }
  },
  mounted () {
    this.fetchVendorList()
    this.fetchDeliverVendorList()
  },
  methods: {
    fetchDeliverVendorList () {
      axios
        .get('/management/campaign/getDeliverVendorList', {
          params: {
            campaign_id: this.campaignID
          }
        })
        .then(res => {
          this.$emit('changeTable', res)
          this.deliverVendorList = res.map(o => {
            return {
              ...o,
              selectUser: o.user[0]
            }
          })
        })
    },
    fetchVendorList () {
      axios
        .get('/admin/struct/getVendorList')
        .then(res => {
          this.vendorList = res
        })
    },
    saveCampaignDeliverVendor (params) {
      return axios.post('/management/campaign/saveCampaignDeliverVendor', format4backend(params))
    },
    handleDeliver () {
      const loading = this.$loading()
      let params = {
        campaign_id: this.campaignID,
        campaign_deliver_vendor: this.deliverVendorList.map(o => {
          let res = {
            campaign_deliver_vendor_id: o.campaign_deliver_vendor_id,
            vendor_id: o.vendor_id
          }
          return pickBy(res, v => { return v != null })
        })
      }
      Promise.all([
        this.saveCampaignDeliverVendor(params)
      ])
        .then(res => {
          let param = {
            task_name: this.$store.state.campaign.taskName,
            campaign_id: this.campaignID,
            campaign_deliver_vendor: this.selectedList.map(o => {
              let res = {
                campaign_deliver_vendor_id: o.campaign_deliver_vendor_id,
                vendor_id: o.vendor_id
              }
              return pickBy(res, v => { return v != null })
            }),
            deliver_record: this.selectedList.map(o => {
              let res = {
                id: o.selectUser.id,
                user_id: o.selectUser.user_id
              }
              return [
                pickBy(res, v => { return v != null })
              ]
            })
          }
          axios.post('/management/campaign/deliverVendor', format4backend(param))
            .then(() => {
              loading.close()
              this.$message.success(this.$t('下发成功。'))
              this.fetchDeliverVendorList()
            })
            .catch(() => {
              loading.close()
            })
        })
        .catch(() => {
          loading.close()
        })
    },
    onClick () {
      this.$refs.file.click()
    },
    handleSelectionChange (val) {
      this.selectedList = val
    },
    confirm () {
      if (!this.validateInfo()) return
      const selectedVendorList = this.selectedVendors.map(o => {
        return {
          vendor_id: o.struct_group_id
        }
      })
      const deliverVendorList = this.deliverVendorList.map(o => {
        let res = {
          campaign_deliver_vendor_id: o.campaign_deliver_vendor_id,
          vendor_id: o.vendor_id
        }
        return pickBy(res, v => { return v != null })
      })
      let params = {
        campaign_vendor_basic: {
          campaign_id: this.campaignID,
          is_final_scope: 0
        },
        campaign_vendor: selectedVendorList
      }
      const deliverVendorParams = {
        campaign_id: this.campaignID,
        campaign_deliver_vendor: deliverVendorList.concat(selectedVendorList)
      }
      Promise.all([
        this.savePurchaseRecommendedVendor(params),
        this.saveCampaignDeliverVendor(deliverVendorParams)
      ]).then(({res1, res2}) => {
        this.fetchDeliverVendorList()
      })

      this.dialogVisible = false
    },
    validateInfo () {
      if (this.selectedVendors.some(i => i.struct_group_id == null)) {
        this.$message.error(this.$t('请选择供应商'))
        return false
      }
      return true
    },
    cancel () {
      this.dialogVisible = false
    },
    savePurchaseRecommendedVendor (params) {
      return axios.post('/management/campaign/savePurchaseRecommendedVendor', format4backend(params))
    },
    clearSelectForm () {
      this.selectedVendors = [
        {
          is_storage: 1,
          struct_group_name: '',
          struct_group_id: null
        }
      ]
    }
  }
}
</script>

<style lang="stylus">
.select-vendors
  .el-dialog
    width: 582px
</style>
